import { render, staticRenderFns } from "./AdminTransactionShowTabular.vue?vue&type=template&id=10f098ea&scoped=true&"
import script from "./AdminTransactionShowTabular.vue?vue&type=script&lang=ts&"
export * from "./AdminTransactionShowTabular.vue?vue&type=script&lang=ts&"
import style0 from "./AdminTransactionShowTabular.vue?vue&type=style&index=0&id=10f098ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f098ea",
  null
  
)

export default component.exports